import { Font } from "@react-pdf/renderer";
import kokilaRegularUrl from "../font/kokila/kokila.ttf";
import kokilaBoldUrl from "../font/kokila/kokilab.ttf";
import kokilaItalicUrl from "../font/kokila/kokilai.ttf";

let registered = false;
let kokilaFontReady = null;

/**
 * Load a webpack font URL as a data URL so @react-pdf never calls window.fetch
 * (unbound fetch causes "Illegal invocation" in some environments).
 */
function fontUrlToDataUrl(fontUrl) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", fontUrl, true);
    xhr.responseType = "arraybuffer";
    xhr.onload = () => {
      if (xhr.status < 200 || xhr.status >= 300) {
        reject(new Error(`Failed to load font (${xhr.status}): ${fontUrl}`));
        return;
      }
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = () =>
        reject(new Error(`Failed to read font file: ${fontUrl}`));
      reader.readAsDataURL(new Blob([xhr.response]));
    };
    xhr.onerror = () => reject(new Error(`Failed to load font: ${fontUrl}`));
    xhr.send();
  });
}

export function registerKokilaFont() {
  if (registered) {
    return Promise.resolve();
  }

  if (!kokilaFontReady) {
    kokilaFontReady = Promise.all([
      fontUrlToDataUrl(kokilaRegularUrl),
      fontUrlToDataUrl(kokilaBoldUrl),
      fontUrlToDataUrl(kokilaItalicUrl),
    ])
      .then(([regular, bold, italic]) => {
        Font.register({
          family: "kokila",
          fonts: [
            { src: regular, fontWeight: "normal" },
            { src: regular, fontWeight: 400 },
            { src: bold, fontWeight: "bold" },
            { src: bold, fontWeight: 700 },
            { src: italic, fontStyle: "italic", fontWeight: "normal" },
            { src: italic, fontStyle: "italic", fontWeight: 400 },
          ],
        });
        registered = true;
      })
      .catch((error) => {
        kokilaFontReady = null;
        throw error;
      });
  }

  return kokilaFontReady;
}
